export function CrossIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='15' height='15' fill='currentFill' fillOpacity='0.01' />
      <g>
        <path d='M18 8H11.99V2H9.01V8H3V11H9.01V17H11.99V11H18V8Z' fill='currentColor' />
        <path
          d='M16.9898 9.01H10.9898V3H10.0098V9.01H4.00977V9.99H10.0098V16H10.9898V9.99H16.9898V9.01Z'
          fill='currentFill'
        />
      </g>
    </svg>
  )
}
